export enum ElectronicFlg {
  ELECTRONIC = 1,
  PAPER = 0,
}

export const ElectronicFlgLabels: Record<ElectronicFlg, string> = {
  [ElectronicFlg.ELECTRONIC]: '電子契約',
  [ElectronicFlg.PAPER]: '書面契約',
};

export const ElectronicFlgValues = Object.fromEntries(
  Object.entries(ElectronicFlgLabels).map(([key, label]) => [label, Number(key)]),
);

export enum PaperFlg {
  WITH_PAPER = 1,
  WITHOUT_PAPER = 0,
}

export const PaperFlgLabels: Record<PaperFlg, string> = {
  [PaperFlg.WITH_PAPER]: 'あり',
  [PaperFlg.WITHOUT_PAPER]: 'なし',
};

export const PaperFlgValues = Object.fromEntries(
  Object.entries(PaperFlgLabels).map(([key, label]) => [label, Number(key)]),
);
